export default {
  markDay: 'Good afternoon, today marks your 100th day at Yijiayuan',
  personalInfo: {
    title: 'Personal Info',
    position: 'Employee of the Hong Kong and Macau Business Expansion team',

    desc: {
      phone: 'Phone',
      mobile: 'Mobile',
      seat: 'Seat',
      email: 'Email',
      position: 'Position',
      leader: 'Leader',
      entity: 'Entity',
      joinDay: 'Day of join',
      group: 'Group',
    },
  },
  profile: {
    title: 'Profile',
    welcome: 'Welcome back, have a great day',
    accountInfo: 'Account Information',
    readOnly: 'Read only, cannot be modified',
    username: 'Username',
    nickname: 'Nickname',
    telephone: 'Phone',
    email: 'Email',
    role: 'Role',
    permissions: 'Permissions',
    permUnit: 'permissions',
    andMore: 'and {count} more',
    lastLogin: 'Last Login',
    permissionInfo: 'Permissions',
    systemInfo: 'System Info',
    systemName: 'System',
    accountType: 'Account Type',
    adminAccount: 'Admin Account',
  },
  contentList: 'Content List',
  visitData: 'Visit Data',
  teamMember: 'Team Member',
  serviceProduction: 'Service Product',
};
